;(function ($, Drupal, once) {
	Drupal.behaviors.faqValidate = {
		attach: function (context) {
			once('faqValidate', 'html', context).forEach(function (element) {
				const faq_validate = () => {
					const faq_output = $('.faq-output')
					const faq_output_visual = $('.faq-output-visual')

					const faq_selects = $('.faq-questions select')
					const faq_checkmark = $('.faq-checkmark')
					let text = '' // A string
					let status = 'disabled' // progress, valid, question or disabled
					let results = {}
					let display_results = false
					let number_of_answers = 0
					let progress_percent = 0

					let faq_selects_index = 0

					faq_selects.each(function () {
						let value = $(this).val()

						results[faq_selects_index] = value

						faq_selects_index++

						if (value) {
							display_results = true
							number_of_answers++
						}
					})

					// Check for empty results. If there are, set progress bar classes
					const number_of_selects = faq_selects.length
					if (number_of_answers !== number_of_selects) {
						text = 'Keep going!'

						progress_percent =
							(100 / number_of_selects) * number_of_answers
						status = 'progress'

						if (number_of_answers == 1) {
							text = 'Looks good, three questions left.'
						} else if (number_of_answers == 2) {
							text = 'Halfway there!'
						} else if (number_of_answers == 3) {
							text = 'Only one question left!'
						}
					}

					// If all answers are filled, set states
					if (number_of_answers === number_of_selects) {
						progress_percent = 100
						status = 'valid'
						text = 'Yes, it will work on your data!'
						faq_checkmark.removeClass('hidden')
						faq_output_visual.addClass('hidden')

						// Check for discrepancies
						if (results[0] == 'other') {
							status = 'question'
							text = 'Contact us to discuss your type of data.'
						} else if (results[0] == 'ngs' || results[0] == 's1_v9') {
							status = 'valid'
							text = 'Yes, it will work with the NGS Module.'
						} else if (results[3] == 'other') {
							status = 'question'
							text = 'Contact us to discuss your hardware set-up.'
						} else if (results[1] == 's2_v3' && results[2] == 'other') {
							status = 'valid'
							text = 'Yes, it will work if you have less than 200 000 variables and a performance computer.'
						} else if (results[1] == 'other') {
							status = 'valid'
							text = 'Yes, it will work but require prefiltering of variables to ensure high interactivity. A high performance computer is recommended.'
						} else if (results[2] == 'other') {
							status = 'valid'
							text = 'Yes, it will work if you have less than 1000 samples and a high performance computer.'
						}
					}

					// Set states
					faq_output
						.removeClass('faq-output-disabled')
						.removeClass('faq-output-progress')
						.removeClass('faq-output-valid')
						.removeClass('faq-output-question')
						.removeClass('group/question')
						.removeClass('group/valid')
						.removeClass('group/progress')
						.removeClass('hidden')
						.addClass('faq-output-' + status)
						.addClass('group/' + status)
						.addClass('flex')

					faq_output.find('.faq-output-text').text(text)
					faq_output
						.find('.faq-progress-bar')
						.css('width', progress_percent + '%')
				}

				$('.faq-questions select').change(function () {
					faq_validate()
				})
			})
		},
	}
})(jQuery, Drupal, once)
